var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon16PxReceiptOutline(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.17091 6.07244C8.12138 5.93232 8.04496 5.80489 7.94784 5.69638C7.74125 5.46556 7.44104 5.32031 7.1069 5.32031H6.23364C5.67744 5.32031 5.22656 5.77119 5.22656 6.32738C5.22656 6.80064 5.5561 7.21005 6.01843 7.31119L7.348 7.60203C7.86594 7.71533 8.2351 8.17432 8.2351 8.70451C8.2351 9.3276 7.72999 9.83313 7.1069 9.83313H6.35476C5.86354 9.83313 5.44564 9.51918 5.29076 9.08099",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.73047 5.31961V4.19141",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.73047 10.9622V9.83398",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2308 2.5H4.19231C3.74348 2.5 3.31304 2.6783 2.99567 2.99567C2.6783 3.31304 2.5 3.74348 2.5 4.19231V13.5L4.61538 12.2308L6.73077 13.5L8.84615 12.2308L10.9615 13.5V3.76923C10.9615 3.43261 11.0952 3.10977 11.3333 2.87175C11.5713 2.63372 11.8942 2.5 12.2308 2.5ZM12.2308 2.5C12.5674 2.5 12.8903 2.63372 13.1283 2.87175C13.3663 3.10977 13.5 3.43261 13.5 3.76923V6.73077H10.9615",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon16PxReceiptOutline);
export default __webpack_public_path__ + "static/media/icon_16px_receipt_outline.d1fdef8a78a7c6adc36129f0c9b5d3d1.svg";
export { ForwardRef as ReactComponent };